import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const courseDiscussionCommentEditApi = createAsyncThunk(
    'auth/courseDiscussionComments/Edit',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.put(apiRoutes.publicapiAction("discussion/comments/update", 1), data)
            return response?.data
        } catch (error) {
            let errorData = error?.response?.data || {};
            if (!errorData.message) {
                errorData.message = "Something went wrong.";
            }
            return rejectWithValue(errorData)
        }
    }
)

const courseDiscussionCommentEditSlice = createSlice({
    name: 'courseDiscussionComment Edit',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(courseDiscussionCommentEditApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(courseDiscussionCommentEditApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(courseDiscussionCommentEditApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const { resetCourseDiscussionCommentEdit } = courseDiscussionCommentEditSlice.actions
export const courseDiscussionCommentEditReducer = courseDiscussionCommentEditSlice.reducer
